import React, { useState } from 'react';
import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import { TextField, Button, Typography } from '@material-ui/core';
import Modal from 'sharedComponents/Modal';
import { getServerError } from 'utils/errors';
import CustomNumberInput from './components/CustomNumberInput';

import useStyles from './useStyles';

const INITIAL_CREDIT_CARD_VALUES = {
  cardAmount: 1,
  cardNumber: '',
  cardName: '',
  cardExpiry: '',
  cardCvc: '',
};

const CreditCardModal = props => {
  const { t } = useTranslation();
  const [creaditCardValues, setCreditCardValues] = useState(INITIAL_CREDIT_CARD_VALUES);
  const [error, setError] = useState(null);
  const { onClose, onFinish, onSave, isLoading } = props;
  const classes = useStyles();

  const handleInputChange = ({ target: { name, value } }) => {
    setCreditCardValues({ ...creaditCardValues, [name]: value });
  };

  const handleError = err => {
    const errors = getServerError(err).split(',');
    if (errors.length < 3) {
      setError(errors);
      return;
    }
    setError(errors[1].trim());
  };

  const handleSave = async () => {
    try {
      setError(null);
      await onSave({ creditCard: creaditCardValues });
      onFinish();
    } catch (err) {
      handleError(err);
    }
  };

  const hasError = !isBlank(error);

  return (
    <Modal onClose={onClose} label={t('components.SubscriptionPage.CreditCardModal.header')} closeButton header>
      <Cards
        number={creaditCardValues.cardNumber}
        name={creaditCardValues.cardName}
        expiry={creaditCardValues.cardExpiry}
        cvc={creaditCardValues.cardCvc}
      />
      {hasError && (
        <Typography variant="body1" color="error" className={classes.errorMessage}>
          {error}
        </Typography>
      )}
      <div>
        <TextField
          key="cardNumber"
          name="cardNumber"
          variant="outlined"
          InputProps={{
            inputComponent: CustomNumberInput,
          }}
          onChange={handleInputChange}
          value={creaditCardValues.cardNumber}
          className={classes.field}
          placeholder={t('components.SubscriptionPage.CreditCardModal.cardNumber')}
        />
        <TextField
          key="cardName"
          name="cardName"
          variant="outlined"
          onChange={handleInputChange}
          value={creaditCardValues.cardName}
          className={classes.field}
          placeholder={t('components.SubscriptionPage.CreditCardModal.cardName')}
        />
        <div className={classes.coupledFields}>
          <TextField
            key="cardExpiry"
            name="cardExpiry"
            variant="outlined"
            InputProps={{
              inputComponent: CustomNumberInput,
            }}
            onChange={handleInputChange}
            value={creaditCardValues.cardExpiry}
            className={classes.coupledField}
            placeholder={t('components.SubscriptionPage.CreditCardModal.cardExpiry')}
          />
          <TextField
            key="cardCvc"
            name="cardCvc"
            variant="outlined"
            InputProps={{
              inputComponent: CustomNumberInput,
            }}
            onChange={handleInputChange}
            value={creaditCardValues.cardCvc}
            className={classes.coupledField}
            placeholder={t('components.SubscriptionPage.CreditCardModal.cardCvc')}
          />
        </div>
      </div>
      <Button onClick={handleSave} className={classes.saveButton} disabled={isLoading}>
        {t('components.SubscriptionPage.CreditCardModal.saveButton')}
      </Button>
    </Modal>
  );
};

CreditCardModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default CreditCardModal;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/components/CreditCardModal/CreditCardModal.js